import { useLang } from "@/lib/lang";
import { MapPin } from "lucide-react";

export default function Audience() {
  const { t } = useLang();
  const items = [
    { key: "india", tint: "var(--mustard)" },
    { key: "canada", tint: "var(--terracotta)" },
    { key: "usa", tint: "var(--sage)" },
  ];
  return (
    <section className="py-16 md:py-24" style={{ background: "var(--bg-paper)" }}>
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <h2 className="font-display text-3xl md:text-5xl max-w-2xl" style={{ color: "var(--primary)" }}>
          {t.audience.title}
        </h2>
        <div className="mt-10 grid md:grid-cols-3 gap-5">
          {items.map((it) => (
            <div key={it.key} data-testid={`audience-${it.key}`} className="card-soft p-7 relative overflow-hidden">
              <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full opacity-20" style={{ background: it.tint }} />
              <div className="w-11 h-11 rounded-2xl flex items-center justify-center" style={{ background: it.tint, color: "white" }}>
                <MapPin size={20} />
              </div>
              <div className="mt-5 font-display text-2xl" style={{ color: "var(--primary)" }}>{t.audience[it.key]}</div>
              <div className="mt-2 text-sm" style={{ color: "var(--text-secondary)" }}>{t.audience[it.key + "_sub"]}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
